// External Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getBudtenderAvgSales, getCsvReport } from 'actions/ReportsAction';
import { getAllEmployees } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
import { checkDateRange, getDollarFormat, roundToDecimalPlace } from 'utils/helpers';
import { reportBudtenderSalesCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import Pagination from 'screens/components/basic/Pagination';
// Local Components
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import "./BudtenderAvgSales.scss"

class BudtenderAvgSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            totalRow: 0,
            showBody: false,
            itemsPerPage: 25
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `BudtenderAverageSalesBeginDate`);
        this.props.formInput(date, `BudtenderAverageSalesEndDate`)
        this.props.getEmployees();
        if (localStorage.getItem("HightideReportsBranchIds") != null) {
            this.props.formInput(localStorage.getItem("HightideReportsBranchIds").split(","), "HightideReportsBranchIds")
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds ? this.props.selectedBranchIds.join(",") : this.props.loggedBranch;
        let itemsPerPage = this.state.itemsPerPage;
        let pageNumber = this.state.activePage;
        let employeeId = this.props.selectedEmployeeId || 0;

        this.props.getBudtenderAvgSales({ beginDate, endDate, branchIds, itemsPerPage, pageNumber, employeeId });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.selectedBranchIds ? this.props.selectedBranchIds.join(",") : this.props.loggedBranch;
        let employeeId = this.props.selectedEmployeeId || 0;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/budtenderaveragesales?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branchIds}&employeeId=${employeeId}`, "budtenderaveragesales");
        }

    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    getEmployeeOptions = () => {
        var employeeOptions = (this.props.employees || []).map(item => {
            return {
                text: `${item.firstName} ${item.lastName}`,
                value: item.id.toString()
            };
        });
        return [{
            text: `All`,
            value: '0'
        }, ...employeeOptions];
    }

    getDataForPlotting = (budtenderAverageSales) => {
        let grossSalesAllEmployees = budtenderAverageSales.grossSalesAllEmployees;

        let finalArray = budtenderAverageSales.results.map(employee => {
            return ({
                budtender: employee.budtender,
                grossSalesAmount: employee.totalGrosssales,
                grossSalesPercentage: roundToDecimalPlace(employee.totalGrosssales / grossSalesAllEmployees * 100, 2),
                numberOfOrders: employee.numberOfOrders
            })
        })

        return finalArray;
    }

    customTooltip = ({ payload, label, active }) => {
        if (active) {
            let data = payload[0].payload;

            return (
                <div className="custom-tooltip">
                    <span className="fw_bold">{data.budtender}</span>
                    <br />
                    <span>Gross Sales: {getDollarFormat(data.grossSalesAmount)}</span>
                    <br />
                    <span>Number of orders: {data.numberOfOrders}</span>
                    <br />
                    <span>Percentage: {data.grossSalesPercentage}</span>
                </div>
            );
        }

        return null;
    }

    render() {
        let budtenderAvgSalesFiltered = this.props.budtenderAvgSales.results ? this.props.budtenderAvgSales.results.filter(_ => _.employeeId == this.props.budtenderAvgSales.selectedEmployeeId) : []
        const totalRow = this.props.budtenderAvgSales.results ? (this.props.budtenderAvgSales.selectedEmployeeId == 0 ? this.props.budtenderAvgSales.total : budtenderAvgSalesFiltered.length) : 0;

        return (
            <Grid headerContent={reportBudtenderSalesCrumb} className={"bud-tender-avg-sales-container"}>
                <PageHeader title={LOOKUP.report.budtenderAvgSales.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/budtender-average-sales" />}
                    description={LOOKUP.report.budtenderAvgSales.description}
                />
                <Header
                    branchOptions={this.props.branchOptions}
                    defaultBranch={this.props.defaultBranch}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    employeeOptions={this.getEmployeeOptions()}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.budtenderAvgSales &&
                    <CardSimple>
                        <Body
                            budtenderAvgSales={this.props.budtenderAvgSales}
                            budtenderAvgSalesFiltered={budtenderAvgSalesFiltered}
                            beginDate={this.props.beginDate}
                            selectedBranchIds={this.props.selectedBranchIds}
                            endDate={this.props.endDate}
                            dataForPlotting={this.getDataForPlotting}
                            customTooltip={this.customTooltip} />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        branchOptions: branchOptions,
        budtenderAvgSales: state.reports.budtenderAvgSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.BudtenderAverageSalesBeginDate,
        endDate: state.form.BudtenderAverageSalesEndDate,
        defaultBranch: branchOptions,
        branch: state.form.BudtenderAverageSalesBranchOption,
        employees: state.entity.employeeList,
        selectedEmployeeId: state.form.BudtenderAverageSalesEmployeeName,
        selectedBranchIds: state.form.BudtenderAverageSalesBranchOption,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getBudtenderAvgSales: model => dispatch(getBudtenderAvgSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getEmployees: () => dispatch(getAllEmployees()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BudtenderAvgSales));